import { isLoadingSelector, isUpdatedSelector, errorSelector } from '../utils/helperSelectors';
const reducerName = 'paymentUpdate';
export const isPaymentMethodUpdateLoadingSelector = isLoadingSelector(reducerName);
export const isPaymentMethodUpdateUpdatedSelector = isUpdatedSelector(reducerName);
export const paymentUpdateErrorSelector = errorSelector(reducerName);
//# sourceMappingURL=selectors.js.map